import React, {useState, useCallback, Suspense} from 'react'
import {CloseButton} from 'react-bootstrap'

import {useSelector} from "react-redux";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";


const ControlPanel = React.lazy(() => import('views/ControlPanelView'))

export const DashboardContext = React.createContext({
    controlPanelOpen: false,
    toggleControlPanel: () => {}
})

const DashboardLayout = ({mode, children}) => {

    const {theme} = useSelector(state => ({
        theme: state.theme.holiday,
    }))

    const [controlPanelOpen, setControlPanelOpen] = useState(false)
    const renderView = (displayName) => children.find(child => child.type.displayName === displayName) 
    
    const renderTopLeft = () => renderView('TopLeftView')
    const renderBottomLeft = () => renderView('BottomLeftView')
    const renderTopRight = () => renderView('TopRightView')
    const renderBottomRight = () => renderView('BottomRightView')
    const renderMain = () => renderView('MainView')

    const renderMiniScreen = useCallback(() => {
        const active = controlPanelOpen ? 'show' : ''
        return (
            <div className={`mini-screen d-uhd4k-none d-uhd8k-none ${active}`}>
                <CloseButton className="btn-lg" onClick={() => setControlPanelOpen(false) }/>
                <Suspense fallback={<LoadingScreen/>}>
                    <ControlPanel />
                </Suspense>
                
            </div>
        )
    },[controlPanelOpen])

    return (
        <DashboardContext.Provider 
            value={{
                controlPanelOpen: controlPanelOpen,
                toggleControlPanel: () => {
                    setControlPanelOpen((controlPanelOpen) => !controlPanelOpen);
                }
            }}>
            <div className={`App ${mode} ${theme}`}>
                <div className="container-fluid h-100">
                    <div className="wrapper row">
                        <div className="col col-uhd4k-3 d-none d-uhd4k-block d-uhd8k-block p-0">
                            {renderTopLeft()}
                            {renderBottomLeft()}
                        </div>
                        <main className="col col-xs-12 col-uhd4k-6 p-0 main-board">
                            {renderMain()}
                        </main>
                        <div className="col col-uhd4k-3 d-none d-uhd4k-block d-uhd8k-block p-0">
                            {renderTopRight()}
                            {renderBottomRight()}
                        </div>
                    </div>
                    {renderMiniScreen()}
                </div>
            </div>
        </DashboardContext.Provider>
    )
}

DashboardLayout.defaultProps = {
    mode: "daily"
}

export default DashboardLayout

DashboardLayout.MainView = ({children}) => {
    return <Suspense fallback={<LoadingScreen/>}>{children}</Suspense>
}
DashboardLayout.MainView.displayName = "MainView"


const SubView = ({children}) => {
    return (
        <Suspense fallback={<LoadingScreen/>}>
            <div className="subview">{children}</div>
        </Suspense>
    )
}

DashboardLayout.SubView = SubView

DashboardLayout.TopLeftView = ({children}) => <DashboardLayout.SubView>{children}</DashboardLayout.SubView>
DashboardLayout.TopLeftView.displayName = "TopLeftView"

DashboardLayout.BottomLeftView = ({children}) => <DashboardLayout.SubView>{children}</DashboardLayout.SubView>
DashboardLayout.BottomLeftView.displayName = "BottomLeftView"

DashboardLayout.TopRightView = ({children}) => <DashboardLayout.SubView>{children}</DashboardLayout.SubView>
DashboardLayout.TopRightView.displayName = "TopRightView"

DashboardLayout.BottomRightView = ({children}) => <DashboardLayout.SubView>{children}</DashboardLayout.SubView>
DashboardLayout.BottomRightView.displayName = "BottomRightView"